// @file Composable to forcefully change the cursor
import { appendCssToDocumentHead, HTMLStyleElementWrapper } from '@@/bits/css'

// Source: https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
type Cursor =
  | 'auto'
  | 'default'
  | 'none'
  | 'context-menu'
  | 'help'
  | 'pointer'
  | 'progress'
  | 'wait'
  | 'cell'
  | 'crosshair'
  | 'text'
  | 'vertical-text'
  | 'alias'
  | 'copy'
  | 'move'
  | 'no-drop'
  | 'not-allowed'
  | 'grab'
  | 'grabbing'
  | 'all-scroll'
  | 'col-resize'
  | 'row-resize'
  | 'n-resize'
  | 'e-resize'
  | 's-resize'
  | 'w-resize'
  | 'ne-resize'
  | 'nw-resize'
  | 'se-resize'
  | 'sw-resize'
  | 'ew-resize'
  | 'ns-resize'
  | 'nesw-resize'
  | 'nwse-resize'
  | 'zoom-in'
  | 'zoom-out'

export function useForceChangeCursor(): {
  forceChangeCursor: typeof forceChangeCursor
  resetCursor: typeof resetCursor
} {
  let style: HTMLStyleElementWrapper | null = null

  const forceChangeCursor = (cursor: Cursor): void => {
    resetCursor()
    style = appendCssToDocumentHead(
      // Without !important, the cursor can still
      // be changed by the browser according to
      // its default behavior. E.g. hovering a
      // link will change the cursor to pointer.
      `
        body * {
          cursor: ${cursor} !important;
        }
      `,
    )
  }

  const resetCursor = (): void => {
    style?.remove()
    style = null
  }

  return { forceChangeCursor, resetCursor }
}
